import { useMutation } from "@apollo/client/react";
import { ArrowLeftOutlined, PlusOutlined } from "@ant-design/icons";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { assert } from "ts-essentials";
import {
  CreateIngredientDocument,
  type GenericIngredientFragment,
  type IngredientFragment,
} from "../../gql/generated/graphqlSchema.tsx";
import { genericIngredientDisplayName } from "../../utils/genericIngredient.ts";
import { GenericIngredientSearch } from "./edit/GenericIngredientSearch.tsx";

export const CreateFromGenericView = ({
  onBack,
  onCreated,
}: {
  readonly onBack: () => void;
  readonly onCreated: (ingredient: IngredientFragment) => void;
}) => {
  const { t, i18n } = useTranslation();
  const [createIngredient] = useMutation(CreateIngredientDocument);
  const [submitting, setSubmitting] = useState(false);

  const handleSelect = (gi: GenericIngredientFragment) => {
    if (submitting) return;
    setSubmitting(true);

    createIngredient({
      variables: {
        input: {
          name: genericIngredientDisplayName(gi, i18n.language),
          genericIngredientId: gi.id,
        },
      },
    })
      .then(({ data }) => {
        const created = data?.createIngredient;
        assert(created != null, "createIngredient returned no data");
        onCreated(created);
      })
      .catch(() => {})
      .finally(() => setSubmitting(false));
  };

  return (
    <GenericIngredientSearch
      actionIcon={<PlusOutlined />}
      actionLabel={t("common.create")}
      cancelIcon={<ArrowLeftOutlined />}
      cancelLabel={t("common.back")}
      onCancel={onBack}
      onSelect={handleSelect}
    />
  );
};
